import React from 'react'

function Referrals() {
  return (
    <div>Referrals</div>
  )
}

export default Referrals